import React, { FC, useEffect } from 'react'
import { Tab, Tabs } from '@material-ui/core'

const MIN_ITEMS = 2

type DatasetTabsProps = {
  activeTab: string
  updatedAt: number
  tabs: { label: string; value: string }[]
  onChange: (tabName: number) => void
}

export const DatasetTabs: FC<DatasetTabsProps> = ({ tabs, updatedAt, activeTab, onChange }) => {
  const [value, setValue] = React.useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
    onChange(newValue || 0)
  }

  useEffect(() => {
    const nextValue = tabs.findIndex(({ label }) => label === activeTab) || 0
    setValue(nextValue)
  }, [tabs, activeTab])

  if (tabs?.length < MIN_ITEMS) return null

  return (
    <Tabs
      value={value}
      onChange={handleChange}
      aria-label="Select dataset tabs"
      textColor="primary"
      indicatorColor="primary"
      style={{ marginBottom: 36 }}>
      {tabs.map((tab, i) => (
        <Tab key={i + tab.label} label={tab.label} />
      ))}
    </Tabs>
  )
}
